import React from "react";
import logo from "../assets/logo.png";
//import "./Header.css";

const Header: React.FC = () => {
  return (
    <header className="app-header">
        <img src={logo} alt="Logo Maria Beatrice" className="header-logo" />
    </header>
  );
};

export default Header;
